<script setup>
  import { onMounted, computed, ref, onBeforeUnmount } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { storeToRefs } from "pinia";

  import CheckInWeightChart from "@/components/Charts/CheckInWeightChart.vue";
  import ClientPageHeader from "@/components/Clients/ClientPageHeader.vue";
  import DisplayGoalSet from "@/components/Clients/DisplayGoalSet.vue";
  import PanelElement from "@/components/ui/PanelElement.vue";
  import SimpleButtonElement from "@/components/ui/SimpleButtonElement.vue";
  import CheckInService from "@/services/CheckInService";

  import { useClientStore } from "@/stores/ClientStore";
  const clientCheckIns = ref(null);
  const { currentClient } = storeToRefs(useClientStore());
  const clientStore = useClientStore();
  const route = useRoute();
  const router = useRouter();

  onMounted(async () => {
    await clientStore.fetchAndSetCurrentClient(route.params.id);
    CheckInService.findAllReviewedByClient(route.params.id).then((res) => {
      clientCheckIns.value = res.data;
    });
  });

  onBeforeUnmount(() => {
    currentClient.value = null;
  });

  const reversedCheckIns = computed(() => {
    return clientCheckIns.value ? [...clientCheckIns.value].reverse() : [];
  });

</script>

<template>
  <div v-if="currentClient">
    <ClientPageHeader :client="currentClient" />
    <div class="space-y-4 mt-6">
      <PanelElement>
        <template #header>
          Weight History
        </template>
        <CheckInWeightChart
          v-if="clientCheckIns"
          :check-ins="reversedCheckIns"
        />
      </PanelElement>
      <PanelElement>
        <template #header>
          Goals
        </template>
        <template #header-actions>
          <SimpleButtonElement
            color="brand-primary"
            @click="router.push({ name: 'EditClientGoals', params: { currentClient: currentClient.id } })"
          >
            Edit Goals
          </SimpleButtonElement>
        </template>
        <DisplayGoalSet
          v-if="currentClient"
          :goals="currentClient.goals"
        />
      </PanelElement>
    </div>
  </div>
</template>
